import axiosInstance from './axiosInstance';

const chatApi = {
    getReferals: (userId) => axiosInstance.post('/referrals/get', { userId }),
};

export default chatApi;
